import CityPageTemplate from "../city-template/CityPageTemplate";
import { toledoConfig } from "./data";

export default function ToledoPage() {
  return <CityPageTemplate config={toledoConfig} />;
}